export enum LimitedListItemType {
    Usual = "usual",
    All = "all",
    Remaining = "remaining",
}

export interface ILimitedListItemModel {
    value: number;
    cost: number;
    type: LimitedListItemType;
    isAvailable: boolean;
}
